export const timeInputMixin = {
  methods: {
    handleTimeKeydown(event, inputObj, key) {
      const input = event.target;
      let val = inputObj[key];
      if (!val || val.length !== 8) val = "00:00:00";

      const start = input.selectionStart;
      const end = input.selectionEnd;

      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Tab', 'Enter', 'Escape', 'Home', 'End'].includes(event.key) || event.ctrlKey || event.metaKey) return;

      event.preventDefault();
      let chars = val.split('');

      const isValidTime = (c) => {
          let h = parseInt(c[0] + c[1]);
          let m1 = parseInt(c[3]);
          let s1 = parseInt(c[6]);
          return h < 24 && m1 < 6 && s1 < 6;
      };

      if (start !== end) {
         if (/^[0-9]$/.test(event.key) || event.key === 'Backspace' || event.key === 'Delete') {
            let sim = [...chars];
            for(let i = start; i < end; i++) {
               if(sim[i] !== ':') sim[i] = '0';
            }
            let targetPos = sim[start] === ':' ? start + 1 : start;
            if (/^[0-9]$/.test(event.key) && targetPos < 8) {
               sim[targetPos] = event.key;
            }
            if (isValidTime(sim)) {
               inputObj[key] = sim.join('');
               if (/^[0-9]$/.test(event.key)) {
                  let nextPos = (targetPos + 1 === 2 || targetPos + 1 === 5) ? targetPos + 2 : targetPos + 1;
                  this.$nextTick(() => { input.setSelectionRange(nextPos, nextPos); });
               } else {
                  this.$nextTick(() => { input.setSelectionRange(start, start); });
               }
            }
         }
         return;
      }

      const pos = start;
      if (/^[0-9]$/.test(event.key)) {
        if (pos < 8) {
          const targetPos = chars[pos] === ':' ? pos + 1 : pos;
          if (targetPos < 8) {
            let sim = [...chars];
            sim[targetPos] = event.key;
            if (isValidTime(sim)) {
               inputObj[key] = sim.join('');
               const nextPos = (targetPos + 1 === 2 || targetPos + 1 === 5) ? targetPos + 2 : targetPos + 1;
               this.$nextTick(() => { input.setSelectionRange(nextPos, nextPos); });
            }
          }
        }
      } else if (event.key === 'Backspace') {
        if (pos > 0) {
          const targetPos = chars[pos - 1] === ':' ? pos - 2 : pos - 1;
          if (targetPos >= 0) {
            chars[targetPos] = '0';
            inputObj[key] = chars.join('');
            this.$nextTick(() => { input.setSelectionRange(targetPos, targetPos); });
          }
        }
      } else if (event.key === 'Delete') {
        if (pos < 8) {
          const targetPos = chars[pos] === ':' ? pos + 1 : pos;
          if (targetPos < 8) {
             chars[targetPos] = '0';
             inputObj[key] = chars.join('');
             this.$nextTick(() => { input.setSelectionRange(targetPos, targetPos); });
          }
        }
      }
    }
  }
};
